import { Link } from "react-router-dom";

export default function TermsAndConditions() {
    return (
        <div
            style={{
                height: "100%",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <header
                style={{
                    position: "sticky",
                    top: 0,
                    width: "100%",
                    display: "flex",
                    zIndex: 1000,
                    color: "black",
                    fontFamily: "'Quicksand', sans-serif",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                }}
            >
                <div style={{ display: "flex", flexDirection: "row", padding: "1% 1% 1% 1%", justifyContent: "space-between", backgroundColor: "#3d5a5a", width: "100%" }}>
                    <Link to="/" style={{ display: "flex", textDecoration: "none" }}>
                        <h1 style={{ color: "#a8d8d8" }}>Mem</h1>
                        <h1 style={{ color: "#d4e8e8" }}>Case</h1>
                    </Link>
                </div>
            </header>

            <main
                style={{
                    backgroundColor: "#7a9a9a",
                    padding: "2rem 10% 6rem",
                    fontFamily: "'Quicksand', sans-serif",
                    color: "#f4f8f8",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "2rem",
                    flexGrow: 1,
                }}
            >
                <section style={{ width: "100%", maxWidth: "600px" }}>
                    <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}>
                        Terms and Conditions
                    </h1>

                    <p>
                        Welcome to <strong>MemCase</strong>! By placing an order with us, you agree to the following terms:
                    </p>

                    <ul style={{ paddingLeft: "1rem", marginTop: "1rem", lineHeight: 1.5 }}>
                        <li>
                            <strong>Personalized Products:</strong> All phone cases are custom-made using your uploaded images and designs. Because each product is unique, all sales are final.
                        </li>
                        <li>
                            <strong>Refunds & Replacements:</strong> We do not offer refunds or exchanges unless the item arrives damaged, defective, or with a manufacturing error (such as a misprint). If this happens, please contact us within 14 days of delivery with photos, and we’ll arrange a replacement.
                        </li>
                        <li>
                            <strong>Order Cancellations:</strong> Orders go into production immediately. For this reason, orders cannot be canceled or modified once they are placed.
                        </li>
                        <li>
                            <strong>Customer Content & Copyright:</strong> You are fully responsible for the images and content you upload. By submitting designs, you confirm that you own the rights or have permission to use them. MemCase is not responsible for copyright violations, offensive material, or legal claims resulting from customer-submitted designs.
                        </li>
                        <li>
                            <strong>Shipping & Delivery:</strong> Average production and shipping time is around 7 business days. Shipping times may vary. We are not responsible for delays caused by carriers, customs, or circumstances outside our control.
                        </li>
                        <li>
                            <strong>Product Use & Liability:</strong> Our phone cases are decorative and protective, but MemCase is not responsible for any damage to your phone or device while using our products.
                        </li>
                        <li>
                            <strong>Governing Law:</strong> These Terms are governed by the laws of the United States.
                        </li>
                    </ul>

                    <p style={{ marginTop: "2rem" }}>
                        If you have any questions about these terms, please contact us at <strong>MemCaseAssist@gmail.com</strong>.
                    </p>
                </section>

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "10%", width: "100%" }}>
                    <Link to='/privacypolicy' style={{ textDecoration: "none", color: "#d4f0f0" }}>
                        Privacy Policy
                    </Link>
                </div>

                <Link to="/" style={{ textDecoration: "none", width: "100%", display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <button style={{
                        padding: "0.75rem 2rem",
                        fontSize: "1rem",
                        backgroundColor: "#6b9e9e",
                        color: "#ffffff",
                        border: "2px solid #3d5a5a",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontFamily: "'Quicksand', sans-serif",
                    }}>
                        Home
                    </button>
                </Link>

                <div style={{ display: "flex", flexDirection: "column", gap: "2%", alignItems: "center", justifyContent: "center", marginTop: "1rem" }}>
                    <div>© {new Date().getFullYear()} MemCase. All Rights Reserved.</div>
                </div>
            </main>
        </div>
    );
}
